import { getActiveSalonId } from 'utils/salonToken';
import { sendMessageToApp } from 'utils/exsternalCall';

const AMBASSADOR_FORM_URL =
  'https://v0-zeta-barber-back-office-wi.vercel.app/f/c9a06c7441f42269397ef8ee?source=app-business';

const EXCLUDED_SALON_IDS = new Set([895, 476, 320, 511, 779, 187, 402, 48, 978, 1410, 111]);

export const isAmbassadorPromoExcluded = (salonId) => EXCLUDED_SALON_IDS.has(Number(salonId));

const withSalonParam = (baseUrl) => {
  const url = new URL(baseUrl);
  const salonId = getActiveSalonId();
  if (salonId != null && salonId !== '') {
    url.searchParams.set('salone', String(salonId));
  }
  return url.toString();
};

const openExternalUrl = (url) => {
  if (localStorage.getItem('fromApp')) {
    sendMessageToApp('app:url', { url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const openAmbassadorForm = () => {
  openExternalUrl(withSalonParam(AMBASSADOR_FORM_URL));
};
